/*
 * @FileName       : createReducer.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Generic function to create reducer.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

export default function createReducer<S, A extends { type: string }>(
	initialState: S,
	handlers: {
		[P in A['type']]?: A extends { type: P } ? (state: S, action: A) => S : never;
	},
) {
	return (state: S = initialState, action: A): S => {
		if (handlers.hasOwnProperty(action.type)) {
			return (handlers as any)[action.type](state, action);
		} else {
			return state;
		}
	};
}
